import Vue from 'vue';
import themes from './theme'
import Vuetify, {
  VApp,
  VContent,
  VContainer,
  VLayout,
  VFlex,
  VToolbar,
  VCard,
  VCardText,
  VWindow,
  VWindowItem,
  VTextField,
  VForm,
  VBtn,
  VStepper,
  VStepperStep,
  VStepperContent,
} from 'vuetify/lib'
import { Ripple } from 'vuetify/lib/directives'
import EyeIcon from 'vue-material-design-icons/Eye.vue'
import EyeOffIcon from 'vue-material-design-icons/EyeOff.vue'
Vue.component('eye-icon', EyeIcon);
Vue.component('eyeoff-icon', EyeOffIcon);

Vue.use(Vuetify, {
  components: {
    VApp,
    VContent,
    VContainer,
    VLayout,
    VFlex,
    VToolbar,
    VCard,
    VCardText,
    VWindow,
    VWindowItem,
    VTextField,
    VForm,
    VBtn,
    VStepper,
    VStepperStep,
    VStepperContent,
  },
  directives: {
    Ripple,
  },
})

export default new Vuetify({
  theme: {
    dark: false,
    themes
  },
});